import { render, staticRenderFns } from "./Collaterals.vue?vue&type=template&id=958473f0&scoped=true&"
import script from "./Collaterals.vue?vue&type=script&lang=js&"
export * from "./Collaterals.vue?vue&type=script&lang=js&"
import style0 from "./Collaterals.vue?vue&type=style&index=0&id=958473f0&prod&lang=scss&scoped=true&"
import style1 from "./Collaterals.vue?vue&type=style&index=1&id=958473f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958473f0",
  null
  
)

export default component.exports